<template>
  <div id="app">
    <CreditHeader />
    <b-container>
      <b-card xs="12" md="8" offset-md="2" lg="6" offset-lg="3">
            <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
	<div slot="header">
		<b-button :to="{ name: 'search' }" class="position-absolute d-md-block d-none" style="left: 15px" @click="clear">Back to Search</b-button>
		<h3>Dorset Playhouse Database</h3>
	</div>
      	<router-view />
      </b-card>
    </b-container>
  </div>
</template>

<script>
import FeaturePerformance from './components/data-items/FeaturePerformance.vue'
import Search from './components/Search.vue'
import CreditHeader from './components/CreditHeader.vue'

export default {
	name: 'app',
	components: {
		Search,
		FeaturePerformance,
		CreditHeader
	},
	methods: {
		clear() {
			this.$store.dispatch('search/clear')
		}
	}
}
</script>

<style>
body {
	text-align: center;
	background-color: #330000;
}
.pointer {
	cursor: pointer;
}
.pointer:hover {
	background-color: #fdd;
}
@media (min-width: 576px) {
	.card-columns {
		column-count: 1;
	}
}

@media (min-width: 768px) {
	.card-columns {
		column-count: 2;
	}
}

@media (min-width: 992px) {
	.card-columns {
		column-count: 3;
	}
}

@media (min-width: 1200px) {
	.card-columns {
		column-count: 3;
	}
}
</style>
